import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ContactForm = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <div className="bg-background-light p-6 rounded-lg h-full">
      <h3 className="text-xl font-bold mb-4">{t('footer.contact')}</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-4">
          <div>
            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="form-input"
            />
          </div>
          <div>
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="form-input"
            />
          </div>
          <div>
            <textarea
              placeholder="Message"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              rows={3}
              className="form-input resize-none"
            />
          </div>
        </div>
        <button
          type="submit"
          className="w-full bg-secondary text-white py-2 rounded hover:bg-secondary-dark transition-colors"
        >
          {t('footer.submit')}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;